import type { ImageUploadState } from './context';

export const defaultContext: ImageUploadState = {
	image: undefined,
	imageChanged: false,
	imageCrop: undefined,
	errorMessage: null,
	fileType: null,
	cropper: undefined,
};
